// API must be isomorphic with `iso-ssr.mjs`.

import * as uv from './util-view.mjs'

/*
Replaces the CHILDREN of the target element. This does not affect the properties
and attributes of the target.

Callers should use this ONLY on elements connected to the DOM. Avoid calling
this on elements disconnected from the DOM, because if the element is never
connected, `componentWillUnmount` will not be invoked.
*/
export function renderReactChildrenIntoDomElement(ctx, tar, chi) {
  uv.preactRender(tar, uv.withCtx(ctx, chi))
  return tar
}
